import { cn } from '@/utilities/ui'
import aboutOff from '../svgs/icon_nav_dd_about_off.svg'
import aboutOn from '../svgs/icon_nav_dd_about_on.svg'
import grantsOff from '../svgs/icon_nav_dd_grants_off.svg'
import grantsOn from '../svgs/icon_nav_dd_grants_on.svg'
import projectsToolsOff from '../svgs/icon_nav_dd_projects_tools_off.svg'
import projectsToolsOn from '../svgs/icon_nav_dd_projects_tools_on.svg'
import provideStorageOff from '../svgs/icon_nav_dd_provide_storage_off.svg'
import provideStorageOn from '../svgs/icon_nav_dd_provide_storage_on.svg'
import roadmapOff from '../svgs/icon_nav_dd_roadmap_off.svg'
import roadmapOn from '../svgs/icon_nav_dd_roadmap_on.svg'
import storeDataOff from '../svgs/icon_nav_dd_store_data_off.svg'
import storeDataOn from '../svgs/icon_nav_dd_store_data_on.svg'
import techOverviewOff from '../svgs/icon_nav_dd_tech_overview_off.svg'
import techOverviewOn from '../svgs/icon_nav_dd_tech_overview_on.svg'
import whitepaperOff from '../svgs/icon_nav_dd_whitepaper_off.svg'
import whitepaperOn from '../svgs/icon_nav_dd_whitepaper_on.svg'
import docsOff from '../svgs/icon_nav_dd_docs_off.svg'
import docsOn from '../svgs/icon_nav_dd_docs_on.svg'
import docsSquareOff from '../svgs/icon_nav_dd_docs_square_off.svg'
import docsSquareOn from '../svgs/icon_nav_dd_docs_square_on.svg'
import favicon from '../svgs/favicon.svg'

type Props = {
  icon:
    | 'about'
    | 'grants'
    | 'projects_tools'
    | 'provide_storage'
    | 'roadmap'
    | 'store_data'
    | 'use_storage'
    | 'tech_overview'
    | 'whitepaper'
    | 'docs'
    | 'docs_square'
    | 'favicon'
    | string
  className?: string
}

const iconMap = {
  about: {
    on: aboutOn,
    off: aboutOff,
  },
  grants: {
    on: grantsOn,
    off: grantsOff,
  },
  projects_tools: {
    on: projectsToolsOn,
    off: projectsToolsOff,
  },
  provide_storage: {
    on: provideStorageOn,
    off: provideStorageOff,
  },
  roadmap: {
    on: roadmapOn,
    off: roadmapOff,
  },
  store_data: {
    on: storeDataOn,
    off: storeDataOff,
  },
  tech_overview: {
    on: techOverviewOn,
    off: techOverviewOff,
  },
  whitepaper: {
    on: whitepaperOn,
    off: whitepaperOff,
  },
  docs: {
    on: docsOn,
    off: docsOff,
  },
  docs_square: {
    on: docsSquareOn,
    off: docsSquareOff,
  },
  favicon: {
    on: favicon,
    off: favicon,
  },
}

export function AbstractNavIcon({ icon, className }: Props) {
  const classes = cn('relative w-[25px] h-[25px]', className)
  const onIcon = iconMap[icon as keyof typeof iconMap] || iconMap.about
  const offIcon = iconMap[icon as keyof typeof iconMap] || iconMap.about
  return (
    <div className={classes}>
      <img
        src={onIcon.on.src}
        alt={icon}
        className={cn(
          classes,
          'absolute top-0 left-0',
          'opacity-0 group-hover/list-item:opacity-100 transition-opacity duration-500',
        )}
      />
      <img
        src={offIcon.off.src}
        alt={icon}
        className={cn(
          classes,
          'absolute top-0 left-0',
          'opacity-100 group-hover/list-item:opacity-0 transition-opacity duration-500',
        )}
      />
    </div>
  )
}
